import { render, staticRenderFns } from "./AddressHistory.vue?vue&type=template&id=a66aee16&"
import script from "./AddressHistory.vue?vue&type=script&lang=js&"
export * from "./AddressHistory.vue?vue&type=script&lang=js&"
import style0 from "./AddressHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports